import { atom } from 'jotai'

// パンくずリストを保持する
export const breadcrumbAtom = atom([{ name: 'マンガBANGブックス' }])
